import React, { FC, forwardRef } from 'react';
import MuiBackdrop, { BackdropProps } from '@material-ui/core/Backdrop';

const Backdrop: FC<BackdropProps> = forwardRef((props, ref) => {
  return (
    <MuiBackdrop ref={ref} {...props}>
      {props.children}
    </MuiBackdrop>
  );
});

export default Backdrop;
